import { render, staticRenderFns } from "./AdsorptionForce.vue?vue&type=template&id=0e22848b&scoped=true"
import script from "./AdsorptionForce.vue?vue&type=script&lang=js"
export * from "./AdsorptionForce.vue?vue&type=script&lang=js"
import style0 from "./AdsorptionForce.vue?vue&type=style&index=0&id=0e22848b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e22848b",
  null
  
)

export default component.exports